import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleRandomizer = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    views: [],
    activeView: "",
    available_swatches: [],
    selectedStyle: "",
    selectedCombination: "",
    selectedSvgSrc: "",
    selectedProductName: "",
    selectedColors: {
      color_1: "",
      color_2: "",
      color_3: ""
    },
    totalCombinations: 24,
    stepNumber: 0,
    modelStyles: [],
    modelsData: {},
    colorTiles: {},
    tallyOfChangesInColorPalette: 0,
    ctaTiles: [],
    defaultRecipe: {},
    productType: '',
    source: ''
  }
};

export default moduleRandomizer;
